export default "__VITE_ASSET__0f001d5e__"